import { format, parseISO, subMonths } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Competência é um mês de calendário (`YYYY-MM`), exibido como `Jul/2026` — não um intervalo.
 * Sem um endpoint de "competências com dado disponível" (ver GR-670), a lista de opções é uma
 * janela rolante de meses até o mês atual; selecionar um mês sem faturas simplesmente devolve
 * uma lista vazia, igual a qualquer outro filtro sem resultado.
 */
export function getBillingPeriodOptions(
  monthsBack = 24,
  referenceDate: Date = new Date(),
): { value: string; label: string }[] {
  const options: { value: string; label: string }[] = [];
  for (let i = 0; i <= monthsBack; i++) {
    const month = subMonths(referenceDate, i);
    const value = format(month, 'yyyy-MM');
    options.push({ value, label: formatBillingPeriodLabel(value) });
  }
  return options;
}

export function formatBillingPeriodLabel(billingPeriod: string): string {
  return format(parseISO(`${billingPeriod}-01`), 'MMM/yyyy', { locale: ptBR });
}
